import * as actions from './kanban.action';
import inicialState from './kanban.state';

const KanbanReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.KANBAN_ATUALIZAR_LOTE_LAMINAS:
      return {
        ...state,
        laminas: action.payload.laminas,
      };
    case actions.KANBAN_ATUALIZAR_MOVER_DISABLED:
      return {
        ...state,
        moverDisabled: action.payload.moverDisabled,
      };
    case actions.KANBAN_ATUALIZAR_MODAL:
      return {
        ...state,
        modal: action.payload.modal,
      };
    case actions.KANBAN_ATUALIZAR_NOVAS_LAMINAS:
      return {
        ...state,
        novasLaminas: action.payload.novasLaminas,
      };
      default:
        return state;
    }
  };

export default KanbanReducer;


// WEBPACK FOOTER //
// ./src/componentes/dragdrog/store/kanban.reducer.js